/* eslint-disable react-hooks/exhaustive-deps */
// External deps
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
// Internal deps
import { Input, Loader, ModalGeneric } from 'ypf-pas-general-ui-components';

import useWorkReport from '../../../../hooks/useWorkReport';
import MonthlyCalendar from '../../../Calendar/MonthlyCalendar/MonthlyCalendar';
import NoWorkReports from '../../NoWorkReports';
import TotalLineSummary from '../../../WorkReportModals/TotalLineModal/TotalLineSummary/TotalLineSummary';
import { formatFullDate, formatsEnum } from '../../../../utils/formatUtils';
import { rectifyALine, sendToApproveLines } from '../../../../services/workReport';
import { PositionLinePermissions } from '../../../MonthlyServiceRequest/RequestDetailTypes';
import useToast from '../../../../hooks/useToast';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';

import LinesMonthHeader from './LinesMonthHeader/LinesMonthHeader';

const enumColors = {
  green: '#FFFFFF,#219E66',
  blue: '#FFFFFF,#159AD8',
  red: '#FFFFFF,#FF6666',
  greenLight: '#219E66,#FFFFFF'
};

const MonthlyView = ({ positionLinesPermissions, disabledEditStateCancelOrFinish }) => {
  const {
    calendarDate,
    linesByMonth,
    fetchLinesByMonth,
    calendarDates,
    fetchMonthlyLines,
    setIdWorkReportLine,
    infoSelectedLine,
    selectedLine,
    setSelectedLine,
    idWorkLineMonthly,
    startDate,
    endDate
  } = useWorkReport();
  const today = new Date();

  const [changeInLine, setChangeInLine] = useState(false);
  const [quantity, setQuantity] = useState('');
  const [modalQuantity, setModalQuantity] = useState({
    show: false,
    data: null
  });
  const [loading, setLoading] = useState(false);
  const [formatedDate, setFormatedDate] = useState(null);
  const todayOlderThanSelectedDate = today < formatedDate;
  const { setNewToast } = useToast();

  const handleChangeQuantity = (day) => {
    // The function is currently not disabled until the calendar is integrated with the notification window data
    const dayFormated = formatFullDate(day);

    setFormatedDate(new Date(formatFullDate(day, formatsEnum.FORMAT_DATE_2)));
    const dataCalendarQuantity = calendarDates.length
      ? calendarDates.find((cd) => formatFullDate(cd.fecha) === dayFormated)
      : null;

    // No se puede editar cantidad que no sea verde/azul sólido
    if (dataCalendarQuantity) {
      const validColor =
        dataCalendarQuantity.colores === enumColors.green ||
        dataCalendarQuantity.colores === enumColors.blue ||
        dataCalendarQuantity.colores === enumColors.greenLight;

      if (validColor) {
        return;
      }
    }

    let quantityDay = null;
    let idWorkReportDaily = 0;
    let hasQuantity = null;

    if (dataCalendarQuantity) {
      quantityDay = dataCalendarQuantity.cantidad || '';
      idWorkReportDaily = dataCalendarQuantity.id;
      hasQuantity = dataCalendarQuantity.cantidad !== null;
      setQuantity(quantityDay);
    }
    const dataLines = linesByMonth[selectedLine.index];

    // Para mostrar label del input
    let label = '';
    const nameDay = day.format('dddd').toUpperCase();
    const dateDay = day.format('DD').toUpperCase();
    const monthName = day.format('MMMM').toUpperCase();

    label = `${nameDay} ${dateDay} DE ${monthName}`;

    setModalQuantity({
      show: true,
      data: {
        ...dataLines,
        id: idWorkReportDaily,
        dia: day,
        label,
        hasQuantity
      }
    });
  };

  const onChangeQuantity = (e) => {
    setQuantity(e.target.value);
  };

  const sendQuantity = async () => {
    setLoading(true);
    try {
      let response = null;

      if (modalQuantity.data?.hasQuantity) {
        response = await rectifyALine({
          id: modalQuantity.data?.id,
          cantidad: Number(quantity)
        });
      } else {
        // setChangeInLines(!changeInLines);
        response = await sendToApproveLines(modalQuantity.data?.idPartetrabajo, [
          {
            id: modalQuantity.data?.id,
            cantidad: quantity
          }
        ]);
      }
      setLoading(false);
      setNewToast({
        type: 'SUCCESS',
        message: response?.mensaje
      });
      setModalQuantity({
        show: false,
        data: null
      });
      fetchLinesByMonth();
    } catch (err) {
      setLoading(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  useEffect(() => {
    if (linesByMonth.length) {
      const positionSelected = linesByMonth[selectedLine?.index];

      setIdWorkReportLine(positionSelected?.idParteLinea);
      fetchMonthlyLines(
        positionSelected?.idParteLinea,
        calendarDate,
        null,
        null,
        positionSelected?.unidadMedida
      );
    }
  }, [selectedLine, linesByMonth]);

  useEffect(() => {
    fetchLinesByMonth();
    setSelectedLine({
      index: 0
    });
  }, [changeInLine]);

  useEffect(() => {
    fetchLinesByMonth();
  }, []);

  return (
    <>
      {linesByMonth.length ? (
        <>
          <Row>
            <Col sm={6}>
              <hr />
              <LinesMonthHeader
                changeInLine={changeInLine}
                disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                idWorkLineMonthly={idWorkLineMonthly}
                positionLinesPermissions={positionLinesPermissions}
                positions={linesByMonth}
                selectedLine={selectedLine}
                setChangeInLine={setChangeInLine}
                setSelectedLine={setSelectedLine}
              />
              <hr />
            </Col>
            <Col sm={6}>
              <div>
                <MonthlyCalendar
                  arrayDate={calendarDates}
                  date={calendarDate}
                  disabled={!positionLinesPermissions.sendToApprove}
                  disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                  handleSelectDay={handleChangeQuantity}
                  line={linesByMonth[selectedLine?.index]}
                  lineBlockedBySap={linesByMonth[selectedLine?.index]?.bloqueadoEnSap}
                  maxDate={endDate}
                  minDate={startDate}
                  showHeader={false}
                />
                <hr />
                <TotalLineSummary lineInfo={infoSelectedLine} simpleView size="small" />
              </div>
            </Col>
          </Row>

          <ModalGeneric
            backdrop="static"
            infoModal
            onHide={() => {
              setModalQuantity({
                show: false,
                data: null
              });
              setQuantity('');
            }}
            primaryAction={() => {
              sendQuantity();
            }}
            primaryActionDisabled={!quantity}
            primaryActionLabel="Enviar"
            secondaryAction={() => {
              setModalQuantity({
                show: false,
                data: null
              });
              setQuantity('');
            }}
            secondaryActionLabel="Salir"
            show={modalQuantity.show}
            size="md"
            title="Cargar y enviar"
          >
            <>
              {loading && <Loader show text="CARGANDO ..." />}
              <p className="text-center modal-info">
                {modalQuantity.data && (
                  <>
                    &quot;
                    {modalQuantity.data.numeroPosicion}-{modalQuantity.data.descripcionPosicionSap}
                    <br />
                    {modalQuantity.data.numeroLinea}-{modalQuantity.data.descripcionLineaSap}&quot;
                    <br />
                  </>
                )}
              </p>
              <hr className="divide-line my-4" />
              <ConditionalWrapper
                condition={todayOlderThanSelectedDate}
                wrapper={(children) => (
                  <OverlayTrigger
                    delay={{
                      show: 250,
                      hide: 400
                    }}
                    overlay={
                      <Tooltip id="button-aprove-all-sds">
                        Linea con fecha posterior a la actual
                      </Tooltip>
                    }
                    placement="top"
                  >
                    {children}
                  </OverlayTrigger>
                )}
              >
                <div>
                  <Input
                    disabled={todayOlderThanSelectedDate}
                    label={modalQuantity.data?.label}
                    name="quantity"
                    onChange={onChangeQuantity}
                    placeholder="Cantidad"
                    type="number"
                    value={quantity}
                  />
                </div>
              </ConditionalWrapper>
            </>
          </ModalGeneric>
        </>
      ) : (
        <NoWorkReports title="No disponés de líneas para la fecha seleccionada" />
      )}
    </>
  );
};

MonthlyView.propTypes = {
  positionLinesPermissions: PositionLinePermissions.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired
};

export default MonthlyView;
